import { BaseContainerModel } from "../../base-container.model";
import { bl_wf_project_notification_subscription_config_RowClass } from "../../../dbschema/bl_wf_project_notification_subscription_config.model";

export class WfProjectNotificationSubscriptionConfigContainerModel extends BaseContainerModel {
  bl_wf_project_notification_subscription_config: bl_wf_project_notification_subscription_config_RowClass = new bl_wf_project_notification_subscription_config_RowClass();
}
